<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LoadingBlock from '@/components/LoadingBlock.vue';
import AppIcon from '@/components/AppIcon.vue';
import { useAuthStore } from '@/stores/auth';
import { useThemeStore } from '@/stores/theme';

const auth = useAuthStore();
const route = useRoute();
const router = useRouter();
useThemeStore();

onMounted(async () => {
  await auth.initialize();
  if (auth.state === 'onboarding' && route.name !== 'onboarding') await router.replace('/onboarding');
  if (auth.state === 'authenticated' && route.name === 'onboarding') await router.replace('/');
});
</script>

<template>
  <div v-if="auth.state === 'loading'" class="launch-screen"><img class="launch-logo" src="/mentoai-logo.svg" alt="MentoAI" /><LoadingBlock /></div>
  <main v-else-if="auth.state === 'outside_telegram'" class="state-screen"><div class="state-symbol"><AppIcon name="sparkles" :size="38" /></div><h1>Откройте MentoAI в Telegram</h1><p>Авторизация работает через защищённые данные Telegram Mini App.</p></main>
  <main v-else-if="auth.state === 'error'" class="state-screen"><div class="state-symbol error">!</div><h1>Не удалось подключиться</h1><p>{{ auth.error }}</p><p v-if="auth.errorDetails" class="caption">{{ auth.errorDetails }}</p><button class="button primary" @click="auth.initialize">Повторить</button></main>
  <div v-else class="app-shell">
    <Suspense><RouterView /><template #fallback><main class="page"><LoadingBlock /></main></template></Suspense>
  </div>
</template>
